import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GTMBaseContentViewObject, PageTracker } from '../../hooks/GTMUtils';
import { Heading } from '../Heading';

export const Error404: FC = () => {
  const [t] = useTranslation();

  return (
    <PageTracker
      gtmTrackingData={{
        ...GTMBaseContentViewObject,
        data: {
          category: 'Error',
          type: 'Page not found',
          content: 'Page not found',
        },
      }}
    >
      <div className="flex flex-col justify-center h-full mx-5 text-center">
        <Heading text={t('components:error404:heading')} align="center" />
        <p>{t('components:error404:body')}</p>
      </div>
    </PageTracker>
  );
};
